// CreateManualTaskModel
class CreateManualTaskModel {
    constructor({created_by = null, created_by_uid = null, location = null, tasks = []} = {}) {
        this.createdBy = created_by;
        this.createdByUid = created_by_uid;
        this.location = location ? Location.fromJson(location) : null;
        this.tasks = tasks.map((task) => Tasks.fromJson(task));
    }

    // Method to convert JSON to CreateManualTaskModel instance
    static fromJson(json) {
        return new CreateManualTaskModel({
            created_by: json.created_by,
            created_by_uid: json.created_by_uid,
            location: json.location,
            tasks: json.tasks,
        });
    }

    // Method to convert CreateManualTaskModel instance to JSON
    toJson() {
        return {
            created_by: this.createdBy,
            created_by_uid: this.createdByUid,
            location: this.location ? this.location.toJson() : null,
            tasks: this.tasks.map((task) => task.toJson()),
        };
    }
}

// Tasks Model
class Tasks {
    constructor({task_type = null, driver_name = null, driver_id = null, vehicle_id = null, orders = [],driverEmail=null} = {}) {
        this.taskType = task_type;
        this.driverName = driver_name;
        this.driverId = driver_id;
        this.vehicleId = vehicle_id;
        this.orders = orders;
        this.driverEmail = driverEmail;
    }

    // Method to convert JSON to Tasks instance
    static fromJson(json) {
        return new Tasks({
            task_type: json.task_type,
            driver_name: json.driver_name,
            driver_id: json.driver_id,
            vehicle_id: json.vehicle_id,
            orders: json.orders,
            driverEmail: json.driver_email,
        });
    }

    // Method to convert Tasks instance to JSON
    toJson() {
        return {
            task_type: this.taskType,
            driver_name: this.driverName,
            driver_id: this.driverId,
            vehicle_id: this.vehicleId,
            orders: this.orders,
            driver_email: this.driverEmail,
        };
    }
}

// Location Model
class Location {
    constructor({
                    type = null,
                    vendor_name = null,
                    vendor_id = null,
                    email = null,
                    id = null,
                    name = null,
                    address = null,
                    country = null,
                    country_id = null,
                    city = null,
                    city_id = null,
                    area = null,
                    lat = null,
                    lng = null,
                    pickup_time = null,
                    landmark = null,
                    phone_code = null,
                    phone_number = null,
                    origin_hub_id = null,
                    origin_hub = null,
                    return_hub_id = null,
                    return_hub = null,
                    return_info_name = null,
                } = {}) {
        this.type = type;
        this.vendorName = vendor_name;
        this.vendorId = vendor_id;
        this.email = email;
        this.id = id;
        this.name = name;
        this.address = address;
        this.country = country;
        this.countryId = country_id;
        this.city = city;
        this.cityId = city_id;
        this.area = area;
        this.lat = lat;
        this.lng = lng;
        this.pickupTime = pickup_time;
        this.landmark = landmark;
        this.phoneCode = phone_code;
        this.phoneNumber = phone_number;
        this.originHubId = origin_hub_id;
        this.originHub = origin_hub;
        this.returnHubId = return_hub_id;
        this.returnHub = return_hub;
        this.returnInfoName = return_info_name;
    }

    // Method to convert JSON to Location instance
    static fromJson(json) {
        return new Location({
            type: json.type,
            vendor_name: json.vendor_name,
            vendor_id: json.vendor_id,
            email: json.email,
            id: json.id,
            name: json.name,
            address: json.address,
            country: json.country,
            country_id: json.country_id,
            city: json.city,
            city_id: json.city_id,
            area: json.area,
            lat: json.lat,
            lng: json.lng,
            pickup_time: json.pickup_time,
            landmark: json.landmark,
            phone_code: json.phone_code,
            phone_number: json.phone_number,
            origin_hub_id: json.origin_hub_id,
            origin_hub: json.origin_hub,
            return_hub_id: json.return_hub_id,
            return_hub: json.return_hub,
            return_info_name: json.return_info_name,
        });
    }

    // Method to convert Location instance to JSON
    toJson() {
        return {
            type: this.type,
            vendor_name: this.vendorName,
            vendor_id: this.vendorId,
            email: this.email,
            id: this.id,
            name: this.name,
            address: this.address,
            country: this.country,
            country_id: this.countryId,
            city: this.city,
            city_id: this.cityId,
            area: this.area,
            lat: this.lat,
            lng: this.lng,
            pickup_time: this.pickupTime,
            landmark: this.landmark,
            phone_code: this.phoneCode,
            phone_number: this.phoneNumber,
            origin_hub_id: this.originHubId,
            origin_hub: this.originHub,
            return_hub_id: this.returnHubId,
            return_hub: this.returnHub,
            return_info_name: this.returnInfoName,
        };
    }
}

export {CreateManualTaskModel, Location, Tasks}

